var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M1.23202 0.908726C1.06417 0.742664 0.792757 0.742664 0.624909 0.908726C0.457061 1.07479 0.458847 1.34799 0.624909 1.51584L3.89258 4.78351L0.624909 8.05119C0.457061 8.21903 0.457061 8.49045 0.624909 8.65651C0.792757 8.82257 1.06417 8.82436 1.23023 8.65651L4.49791 5.38883L7.76737 8.65829C7.93522 8.82614 8.20663 8.82614 8.37269 8.65829C8.53875 8.49045 8.54054 8.21903 8.37269 8.05297L5.10502 4.7853L8.37448 1.51584C8.54233 1.34799 8.54233 1.07657 8.37448 0.910512C8.20663 0.74445 7.93522 0.742664 7.76915 0.910512L4.50148 4.17819L1.23202 0.908726Z",
    fill: "#696E72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXRemove);
export default __webpack_public_path__ + "static/media/x-remove.6c16b73c8bbc0373d17e90a96c7daa53.svg";
export { ForwardRef as ReactComponent };